import * as a11y from '@angular/cdk/a11y';
import * as accordeon from '@angular/cdk/accordion';
import * as bidi from '@angular/cdk/bidi';
import * as coercion from '@angular/cdk/coercion';
import * as collections from '@angular/cdk/collections';
import * as keycodes from '@angular/cdk/keycodes';
import * as layout from '@angular/cdk/layout';
import * as observers from '@angular/cdk/observers';
import * as overlay from '@angular/cdk/overlay';
import * as platform from '@angular/cdk/platform';
import * as portal from '@angular/cdk/portal';
import * as scrolling from '@angular/cdk/scrolling';
import * as stepper from '@angular/cdk/stepper';
import * as table from '@angular/cdk/table';
import * as textField from '@angular/cdk/text-field';
import * as tree from '@angular/cdk/tree';
import { Version } from '@angular/core';

if (window['ng'] == null) window['ng'] = <any>{};

const cdk = {
    a11y: a11y,
    accordeon: accordeon,
    bidi: bidi,
    coercion: coercion,
    collections: collections,
    keycodes: keycodes,
    layout: layout,
    observers: observers,
    overlay: overlay,
    platform: platform,
    portal: portal,
    scrolling: scrolling,
    stepper: stepper,
    table: table,
    textField: textField,
    tree: tree,
    // NOTE inject version because at runtime depending on the app the material bundle will check if the version is the same as the CDK version
    VERSION: new Version(process.env.VERSION)
};
window['ng'].cdk = cdk;

export { cdk };